import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import { Text } from "@ui/components/content/text/Text";
import { Heading } from "@ui/components/content/heading/Heading";

type BenefitItemProps = {
    icon: React.ReactNode; // SVG icon
    title: string; // Title of the benefit
    description: string; // Description of the benefit
};

export const BenefitItem = ({ icon, title, description }: BenefitItemProps) => {
    return (
        <Flex
            flexDirection="column"
            alignItems={{ base: "left", md: "center" }}
            textAlign={{ base: "left", md: "center" }}
            px={[5, 4]}
            py={6}
            w="full"
        >
            <Box mb={4}>{icon}</Box>
            <Heading as="h3" fontSize="xl" mb={2}>
                {title}
            </Heading>
            <Text fontSize="sm" color="gray.600">
                {description}
            </Text>
        </Flex>
    );
};
